<div class="row page-header">
    <div class="col-12">
        <h1>Equipment Analytics <small>View and analyize the status of equipment</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" (activeIdChange)="tabChanged()">
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Idle By Revenue</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar" style="margin-top: 20px">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="idleRevGrid"></action-toolbar-count>
                                    <grid-export [grid]="gridIdleRev" [name]="'Fuel Totals'"></grid-export>
                                    <div class="input-header-group">
                                        <span class="input-header">Past Days</span>
                                        <input
                                            type="number"
                                            class="form-control action-toolbar-input"
                                            [(ngModel)]="pastDays"
                                            name="pastDays"
                                            min="0"
                                        />
                                    </div>
                                    <div class="input-header-group">
                                        <span class="input-header">Hour Threshold</span>
                                        <input
                                            type="number"
                                            class="form-control action-toolbar-input"
                                            [(ngModel)]="hourThreshold"
                                            name="hourThreshold"
                                            min="0"
                                            style="width: 90px"
                                        />
                                    </div>
                                    <button class="btn btn-sm btn-primary" (click)="refresh()">Refresh</button>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <grid-column-group [grid]="idleRevGrid"></grid-column-group>
                                <wj-flex-grid
                                    id="gridIdleRev"
                                    #gridIdleRev
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="idleRevGrid.initialize(gridIdleRev)"
                                    [itemsSource]="idleRevGrid.view"
                                    [itemFormatter]="itemFormatter"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Equipment'" [binding]="'equipment'" [width]="250"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Description'"
                                        [binding]="'description'"
                                        [width]="350"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Category'" [binding]="'category'" [width]="250"></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="gridIdleRev"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="false">
            <a ngbNavLink>Idle By GPS</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar" style="margin-top: 15px">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="idleGpsGrid"></action-toolbar-count>
                                    <grid-export [grid]="gridIdleGps" [name]="'Fuel Totals'"></grid-export>
                                    <div class="input-header-group">
                                        <span class="input-header">Past Days</span>
                                        <input
                                            type="number"
                                            class="form-control action-toolbar-input"
                                            [(ngModel)]="pastDays"
                                            name="pastDays"
                                            min="0"
                                        />
                                    </div>
                                    <div class="input-header-group">
                                        <span class="input-header">Hour Threshold</span>
                                        <input
                                            type="number"
                                            class="form-control action-toolbar-input"
                                            [(ngModel)]="hourThreshold"
                                            name="hourThreshold"
                                            min="0"
                                            style="width: 90px"
                                        />
                                    </div>
                                    <button class="btn btn-sm btn-primary" (click)="refresh()">Refresh</button>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <grid-column-group [grid]="idleGpsGrid"></grid-column-group>
                                <wj-flex-grid
                                    id="gridIdleGps"
                                    #gridIdleGps
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="idleGpsGrid.initialize(gridIdleGps)"
                                    [itemsSource]="idleGpsGrid.view"
                                    [itemFormatter]="itemFormatter"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Equipment'" [binding]="'equipment'" [width]="250"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Description'"
                                        [binding]="'description'"
                                        [width]="350"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Category'" [binding]="'category'" [width]="250"></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="gridIdleGps"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
